import CustomSlider from './CustomSlider';

export default CustomSlider;
